import { z } from "zod";

/**
 * Session timeout configuration
 */
export const PhoneCallSessionTimeoutSchema = z.object({
  max_duration: z.number(),
  max_idle: z.number()
});

export type PhoneCallSessionTimeout = z.infer<typeof PhoneCallSessionTimeoutSchema>;

/**
 * Single source of truth for session-timeout defaults.
 *
 * Used by the deployment-settings factory (initial value at create time)
 * and by the UI when rendering legacy deployments whose stored
 * `session_timeout` is undefined. Keeping both consumers reading from one
 * constant means a future bump (e.g. raising max_duration to 3600s) lands
 * in one place rather than silently diverging between create-time defaults
 * and read-time fallbacks.
 *
 *   max_duration — hard call cap before forced disconnect (seconds)
 *   max_idle     — silence window before idle disconnect (seconds)
 */
export const DEFAULT_PHONE_CALL_SESSION_TIMEOUT: PhoneCallSessionTimeout = {
  max_duration: 1800,
  max_idle: 120
};
